import React from 'react';
import WorldHistory1200ToPresent from '../containers/WorldHistory1200ToPresent';

export default (props) => (
  <WorldHistory1200ToPresent {...props} />
);
